import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import AclContextProvider from '../../../../../Modules/Acl/Components/AclContextProvider';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import { parseBoolean } from '../../../../../Utils/form.util';
import BillingAddressSetupWrapper from './BillingAddressSetupWrapper';

loadDOMComponent({
	selector: 'react-billing-address-setup',
	callback: ({ container, context, props }: any) => {
		const isSuperAdmin = container.getAttribute('isSuperAdmin');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<BillingAddressSetupWrapper
							isSuperAdmin={parseBoolean(isSuperAdmin)}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
